import { Component, Input, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-slot',
  templateUrl: './slot.component.html',
  styleUrls: ['./slot.component.scss']
})
export class SlotComponent implements OnChanges {
  @Input()
  data: {
    value: any,
    higlight: boolean,
    type: string,
    bookedhiglight: boolean,
    show: boolean
  }
  @Input()
  type: string;
  constructor() { }

  ngOnChanges() {
    if (this.type == "flexible")
      this.data.higlight = false;
  }
}
